const menu = {
  defaultProps: {
    disableAutoFocusItem: true,
  },
};
export default menu;
